<template>
  <div class="ecrs-gallery">
    <div class="main-image-outer-wrapper">
      <div class="main-image-wrapper">
        <WCImageWithShadow
          v-if="!activeImage"
          :imageSrc="getDefaultProductImg()"
          class="wc-img-desktop--full-size"
          :alt="productImgAltText(item.name, item.brand)"
          :defaultTitle="noProductImageAltText(item.name)"
        />
        <WCImageWithShadow
          v-if="activeImage"
          :imageSrc="getProductImage(activeImage.id)"
          class="wc-img-desktop--full-size"
          :alt="productImgAltText(item.name, item.brand)"
          :defaultTitle="noProductImageAltText(item.name)"
        />
        <div class="wc-promo-ribbon-wrap">
          <WCPromoRibbon :product="item" :ribbonType="promoRibbonType.SALE_AMOUNT_RIBBON" />
          <WCPromoRibbon :product="item" :ribbonType="promoRibbonType.DISCOUNT_NAME_RIBBON" />
        </div>
      </div>
      <div class="promo-ribbon-container d-none">
        <!-- TODO: Check promo design -->
        <div
          v-if="
            item.suggestedPrice != null &&
              item.actualPrice != null &&
              item.actualPrice / item.actualPriceDivider < item.suggestedPrice
          "
          class="promo-ribbon"
        >
          {{ $t('save') }}
          {{ $filters.currency(item.suggestedPrice - item.actualPrice / item.actualPriceDivider) }}
          <span v-if="item.weightProfile && item.weightProfile.abbrv" class="sales-unit">
            / {{ item.weightProfile.abbrv }}</span
          >
          <span v-if="item.weightProfile && !item.weightProfile.abbrv" class="sales-unit">
            / {{ $t('eachAbbr') }}</span
          >
        </div>
        <div v-if="item.autoDiscount != null" class="promo-ribbon">
          {{ item.autoDiscount }}
        </div>
        <div v-if="item.buyDown != null" class="promo-ribbon">
          {{ item.buyDown }}
        </div>
      </div>
    </div>
    <div class="thumbnails pt-3" v-if="item.images && item.images.length > 1">
      <button
        class="thumbnail unstyled-btn"
        :class="{ active: activeImage === img }"
        v-for="img in item.images"
        :key="img.id"
        @mouseover="activeImage = img"
        @click="activeImage = img"
      >
        <WCImage
          :imageSrc="getProductImage(img.id, 50)"
          :imageAlt="productImgGalleryThumbnailAltText"
          :defaultTitle="noProductImageAltText(item.name)"
          imageClass="gallery__thumbnail"
          defaultClass="gallery__thumbnail"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { PROMO_RIBBON_TYPE } from '@/constants/PromoRibbonConstants';
import WCPromoRibbon from '@/components/WCPromoRibbon/WCPromoRibbon.vue';
import ProductImageInfoMixin from '@/mixins/ProductImageInfoMixin';
import WCImageWithShadow from '@/components/WCImageWithShadow/WCImageWithShadow.vue';
import WCImage from '@/components/WCImage/WCImage.vue';

export default defineComponent({
  props: {
    item: {
      type: Object,
    },
  },
  components: {
    WCImageWithShadow,
    WCPromoRibbon,
    WCImage,
  },
  mixins: [ProductImageInfoMixin],
  computed: {
    productImgGalleryThumbnailAltText() {
      return this.$t('productImgGalleryThumbnailAltText', { name: this.item.name });
    },
    /**
     * Method to get the ribbon type key
     */
    promoRibbonType() {
      return PROMO_RIBBON_TYPE;
    },
  },
  created() {
    this.activeImage = this.item.images ? this.item.images[0] : {};
  },
  data() {
    return {
      activeImage: {},
    };
  },
});
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.ecrs-gallery {
  .main-image-wrapper {
    position: relative;
    .wc-promo-ribbon-wrap {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
    }
  }

  .thumbnails {
    padding: 0;
    margin: 0;

    .thumbnail {
      cursor: pointer;
      display: inline-block;
      position: relative;
      margin: calc($pad-1 / 2);
      padding: $pad-1;
      border-radius: 4px;
      border: 0.5px solid var(--light-darker-4, $gray-600);
      .img {
        max-width: rem(50px);
        max-height: rem(50px);
      }
      &:hover,
      &:focus,
      &.active {
        border: 2px solid var(--secondary, $secondary);
        box-shadow: 0px 3px 6px #00000029;
      }
    }
  }

  .gallery__thumbnail {
    height: rem(50px);
    width: rem(50px);
    object-fit: contain;
  }
}
</style>
